export enum Controltype {
  KalenderDmj = 'KALENDER_001',
  Kalender = 'KALENDER_002',
  KalenderVanTot = 'KALENDER_003',
  SingleChoice = 'SINGLE_CHOICE',
  SingleChoiceWithDescription = 'SINGLE_CHOICE_002',
  SingleChoiceComingDates = 'SINGLE_CHOICE_COMING_DATES',
  SingleChoiceRepair = 'KIESHERSTELLER_001',
  SingleChoiceRepairWithSearch = 'KIESHERSTELLER_002',
  SingleChoiceWithSearch = 'SINGLE_CHOICE_WITH_SEARCH',
  MultiChoice = 'MULTIPLE_CHOICE',
  TekstRegel = 'TEKST_001',
  Tekst = 'TEKST_002',
  Blob = 'BLOB',
  Button = 'BUTTON',
  Summary = 'SUMMARY_001',
  ContactGegevens = 'CONTACTGEGEVENS_001',
  Info = 'INFO',
  Label = 'LABEL',
  Succes = 'SUCCES_001',
  SuccesVerder = 'SUCCES_002', // alleen voor de zakelijke verzekeringskiezer
  SuccesSchadecoach = 'SUCCES_003', // alleen voor de schadecoach
  SuccesFutureState = 'SUCCES_FS', // future state voor AVP
  SuccesButton = 'SUCCES_BUTTON',
  Failure = 'FAILURE_001',
  Number = 'NUMBER',
  Decimaal = 'NUMBER_002',
  Ruithersteller = 'GLAS_001',
  Woonglashersteller = 'GLAS_002',
  MobielSchadeMelden = 'MSM_001',
  Referentie = 'KIESREFERENTIEDATA',
  Telefoon1 = 'KIESTELEFOON_001',
  Telefoon2 = 'KIESTELEFOON_002',
  Telefoon3 = 'KIESTELEFOON_003',
  MultiChoiceDoorvragen = 'MULTIPLE_CHOICE_DOORVRAGEN',
  SliderSingle = 'SLIDER_SINGLE',
  Bedrag = 'BEDRAG_001',
  Tijd = 'TIJD_001'
}
